import {
    GET_PERSONAL_DASHBOARD_PRESENSI,
    GET_PERSONAL_LIST_LOG_PRESENSI,
    GET_PRESENSI_SOURCE_OPTION,
} from 'shared/constants/ActionTypes';

const initialSettings = {
    sourceOption: [],
    dashboard: {
        personal: {
            result: null
        },
    },
    logs: {
        personal: {
            results: []
        }
    }
};

const presensiReducer = (state = initialSettings, action) => {
    switch (action.type) {
        case GET_PERSONAL_DASHBOARD_PRESENSI:
            return {
                ...state,
                dashboard: {
                    ...state.dashboard,
                    personal: action.payload
                },
            };
        case GET_PERSONAL_LIST_LOG_PRESENSI:
            return {
                ...state,
                logs: {
                    ...state.logs,
                    personal: action.payload,
                }
            };
        case GET_PRESENSI_SOURCE_OPTION:
            const data = action.payload.result || []
            return {
                ...state,
                sourceOption: data.map((item) => ({ id: item.key, label: item.name })),
            };
        default:
            return state;
    }
};

export default presensiReducer;
